import { gql } from 'graphql-request';
import { useQueryApplication } from 'src/graphqlhooks';
import { RolePermission } from 'src/types/Permissions';
import { useRequestGQLQuery } from './useGraphQLQuery';

export const GET_LOAN_PRODUCTS_BY_NAMESPACE = `loan_products(where: {object_meta: {_contains: $objectMeta}}) {
  id
  product_name
  product_visual_name
  services
  subproducts
  metadata
}`

export const GET_PERMISSION_BY_ROLE = `roles(where: {object_meta: {_contains: $objectMeta}, _and: {name: {_in: $roles}}}) {
      id
      permissions{
      name
      metadata
      options
      }
    }`;


export const QUERY_CREATE_LOAN_PERMISSIONS = `insert_loan_permissions(objects: $loanPermissions) {
        returning {
          id,
          loanapp_id,
          object_meta,
          metadata,
          options,
          created_at
        }
      }`

export const CREATE_LOAN_PERMISSION = `mutation createLoanPermission($loanPermissions: [loan_permissions_insert_input!]!) {
        ${QUERY_CREATE_LOAN_PERMISSIONS}
}`;

export const QUERY_DELETE_LOAN_PERMISSIONS = `delete_loan_permissions(where: {
          loanapp_id: {_eq: $loanAppId},
          name:{_in: $loanPermissionNames},
          object_meta: {_contains: $objectMeta}
        }) {
          affected_rows
          returning{
            id
            object_meta
            metadata
          }
        }`

export const DELETE_LOAN_PERMISSION_LOAN_ID_AND_NAME = `mutation deleteLoanPermissionsByLoanAccountNames(
  $loanAppId: bigint,
  $objectMeta: jsonb,
  $loanPermissionNames: [String]) {
    ${QUERY_DELETE_LOAN_PERMISSIONS}
  }`;


export const LOAN_PERMISSIONS_QUERY = `loan_permissions(where: {object_meta: {_contains: $permissionObject}, _and: {loanapp_id: {_in: $loanAppIds}}}) {
  id
  name
  object_meta
  loanapp_id
  metadata
  options
}`


const GET_ACTIVITY_AND_LOAN_PERMISSION_BY_ACCOUNT_LOAN = gql`
query describe_loan_permissions_and_activity(
    $objectMeta: jsonb,
    $permissionObject: jsonb,
    $loanAppIds: [bigint]!,
    $resources: [String]!
  ) {
    system_audit_activity(where: {object_meta: {_contains: $objectMeta}, resource:{_in: $resources}}) {
        object_meta
        metadata
        entity_id
        entity_type
        resource
        action
    }
    ${LOAN_PERMISSIONS_QUERY}
 }`;


export interface IGQLPermissionVariable {
  objectMeta: { namespace: string; owner_references: any[] };
  permissionObject: { namespace: string; account: string };
  loanAppIds: string[];
  resources: string[];
}

export const GQLGetLoanPermissionByAccountAndLoan = (variables: IGQLPermissionVariable) => {
  return useRequestGQLQuery(
    GET_ACTIVITY_AND_LOAN_PERMISSION_BY_ACCOUNT_LOAN,
    variables)
}


export const UPSERT_ROLE_PERMISSIONS = `mutation upsertPermissions($permissions: [permissions_insert_input]!) {
  insert_permissions(objects: $permissions, on_conflict: {constraint: permissions_pkey, update_columns: [name, role_id, metadata, description, updated_at, options]}) {
    returning {
      id
      role_id
      name
      description
      options
      updated_at
      created_at
      
    }
  }
}`

const DELETE_ROLE_PERMISSIONS = `mutation deleteRolePermission($names: [String], $roleId: bigint) {
  delete_permissions(where: {name: {_in: $names}, role_id: {_eq: $roleId}}) {
    affected_rows 
    returning {
      id
      name
      role_id
      role {
        name
      }
    }
  }
}
`;

export const DELETE_LOAN_PERMISSION_BY_ID = `
mutation ($id:[bigint!]) {
  delete_loan_permissions(where: {
    id: {_in: $id}}
   ) {
   affected_rows
  }
}
`;

export const GQLDeletePermissions = (roleId: string, names: string[]) => {
  return useRequestGQLQuery(DELETE_ROLE_PERMISSIONS, {
    names,
    roleId
  });
};

export const GQLCreatePermissions = (permissions: RolePermission[]) => {
  return useRequestGQLQuery(UPSERT_ROLE_PERMISSIONS, {
    permissions
  });
};

export const GQLDeleteLoanPermission = (id: any) => {
  const { data } = useQueryApplication(DELETE_LOAN_PERMISSION_BY_ID, {
    variables: {
      id
    }
  });

  return { data };
};